<template>
  <ValidationProvider
    v-slot="{ errors }"
    v-bind="validationAttr"
  >
    <BFormGroup
      v-bind="formGroupAttr"
      :label-for="inputID"
    >
      <!-- PASSWORD INPUT WITH PASSWORD TOGGLE -->
      <BInputGroup
        v-if="$attrs?.type === 'password' && !noPasswordToggle"
        :class="{ 'is-invalid': errors.length > 0 }"
      >
        <BFormInput
          :id="inputID"
          v-model="proxyValue"
          v-bind="$attrs"
          :state="errors.length > 0 ? false : null"
          :type="passwordType"
        />
        <BInputGroupAppend>
          <BButton
            class="pl-2 pr-1 text-dark input-icon"
            variant="success"
            :disabled="$attrs?.disabled || false"
            @click.prevent="togglePasswordType"
          >
            <i
              v-if="isPasswordVisible"
              class="fad fa-eye h6 mb-0 min-w-40px"
            />
            <i
              v-else
              class="fad fa-eye-slash h6 mb-0 min-w-40px"
            />
          </BButton>
        </BInputGroupAppend>
      </BInputGroup>
      <!-- ANY TYPE OF INPUT -->
      <BFormInput
        v-else
        :id="inputID"
        v-model="proxyValue"
        v-bind="$attrs"
        :state="errors.length > 0 ? false : null"
      />
      <div
        v-if="(errors.length > 0)"
        class="invalid-feedback"
        v-text="errors[0]"
      />
    </BFormGroup>
  </ValidationProvider>
</template>
<script>
import MISC from '@/mixins/misc'

export default {
  name: 'WVInput',

  mixins: [
    MISC
  ],

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    validationAttr: {
      type: Object,
      default: () => ({})
    },
    formGroupAttr: {
      type: Object,
      default: () => ({})
    },
    noPasswordToggle: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isPasswordVisible: false,
      inputID: `_CINPUT_${this.generateId(5)}_${this._uid}`
    }
  },

  computed: {
    proxyValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    passwordType () {
      return this.isPasswordVisible ? 'text' : 'password'
    }
  },

  methods: {
    togglePasswordType () {
      this.isPasswordVisible = !this.isPasswordVisible
    }
  }
}
</script>
